export default {
  testimonial_supplier: {
    subtitle: "آراء الموردين",

    title1: "ماذا يقول",
    title2: "الموردون",

    desc:
      "يثق الموردون في MAHAL لتنمية أعمالهم والتواصل مع المطاعم.",

    review:
      "جعلت MAHAL عملياتنا سهلة وشفافة. الطلبات والمدفوعات سلسة.",

    cta: "انضم إلى MAHAL اليوم",

    users: [
      { name: "بارثولوميو", role: "مورد" },
      { name: "صوفي", role: "موزع" },
      { name: "إسرات", role: "شريك" },
    ],
  },
};